export default __webpack_public_path__ + "static/media/react_original_wordmark_logo_icon_146375.598c2743.png";